import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'
import { ReactComponent as StomatologyIcon } from '../../../../../../assets/icons/stomatology.svg'
import { ReactComponent as PulmonologyIcon } from '../../../../../../assets/icons/pulmonology.svg'

export default function index({ t, selectedOperation, operations, setSelectedOperation, apt, isNew, setIsNew }) {
  const [searchInput, setSearchInput] = useState('')
  const [opMenu, setOpMenu] = useState(false)
  const [searchCategory, setSearchCategory] = useState(['stomatology', 'pulmonology'])
  const menuRef = useRef(null)
  const unitaryMultiplier = apt?.unit_multiplier || 1

  const multiplierSpanRef = useRef(null)

  const onMultiplierChange = (e) => {
    const { value } = e.target
    multiplierSpanRef.current.textContent = `${t('full_price')}: ${(Number(selectedOperation?.price) || 0) * (Number(value) || 1)} €`
  }

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpMenu(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleCategoryChange = (newCat) => {
    if (searchCategory.includes(newCat)) {
      setSearchCategory(searchCategory.filter((cat) => cat !== newCat))
    } else {
      setSearchCategory([...searchCategory, newCat])
    }
  }

  const filteredOperations = operations?.filter((op) => {
    const searchInputLower = searchInput.toLowerCase()
    const opNameLower = op.op_name.toLowerCase()
    const opCategoryLower = op.category.toLowerCase()
    return (
      (searchCategory.includes(opCategoryLower) || searchCategory.length === 0) &&
      (opNameLower.includes(searchInputLower) || searchInputLower === '')
    )
  })

  return (
    <>
      <div className={styles.container} ref={menuRef}>
        <label className={styles.entry_label} htmlFor='op_name'>
          {t('operation_name')}
        </label>
        <div className={`${styles.op_selector_container} ${opMenu ? styles.active_menu : ''}`}>
          <input
            type='text'
            id='op_name'
            name='op_name'
            defaultValue={selectedOperation?.op_name || ''}
            placeholder={t('select_operation')}
            className={styles.selector_input}
            autoComplete='off'
            onClick={() => setOpMenu(!opMenu)}
          />
          <div className={styles.op_menu_container}>
            <div className={styles.op_menu_search}>
              <input
                className={styles.op_menu_search_input}
                value={searchInput}
                placeholder={t('search')}
                onChange={(e) => setSearchInput(e.target.value)}
              />
              <button
                className={`${styles.op_category_search_btn} ${searchCategory.includes('stomatology') ? styles.active : ''}`}
                type='button'
                onClick={() => handleCategoryChange('stomatology')}
              >
                <StomatologyIcon className={styles.btn_icon_sto} />
              </button>

              <button
                className={`${styles.op_category_search_btn} ${searchCategory.includes('pulmonology') ? styles.active : ''}`}
                type='button'
                onClick={() => handleCategoryChange('pulmonology')}
              >
                <PulmonologyIcon className={styles.btn_icon_pul} />
              </button>
            </div>
            <div className={styles.op_menu_list_container}>
              {filteredOperations?.map((op) => (
                <li
                  key={op.id}
                  className={styles.op_menu_item}
                  onClick={() => {
                    setSelectedOperation(op)
                    setOpMenu(false)
                  }}
                >
                  <span className={styles.op_menu_text}>{op.op_name}</span>
                </li>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.op_info_container}>
          <span className={styles.entry_label}>
            {t('Price')}: {(isNew ? selectedOperation?.price || 'N/A' : '0') + ' €'}
            {selectedOperation?.price && t(selectedOperation?.unitary ? 'in_Unit' : 'in_Full')}
          </span>
          <span className={styles.entry_label}>
            {t('category')}: {selectedOperation?.category || 'N/A'}
          </span>
          <span className={styles.entry_label}></span>
        </div>
        {selectedOperation?.unitary && isNew && (
          <div className={styles.form_entry}>
            <div className={styles.unitary_container}>
              <label className={styles.entry_label} htmlFor='unit_multiplier'>
                {t('units')}
              </label>
              <input
                defaultValue={unitaryMultiplier}
                onChange={onMultiplierChange}
                min={1}
                className={styles.entry_input}
                required
                type='number'
                id='unit_multiplier'
                name='unit_multiplier'
              />
              <span className={styles.entry_label} ref={multiplierSpanRef}>
                {t('full_price')}: {(Number(selectedOperation?.price) || 0) * (Number(unitaryMultiplier) || 1) + ' €'}
              </span>
            </div>
          </div>
        )}
      </div>
      {selectedOperation && (
        <div className={styles.radio_container}>
          <div className={styles.radio_input_container}>
            <input checked={isNew} onChange={() => setIsNew(true)} className={styles.entry_input} type='radio' id='is_new' name='is_new' />
            <label className={styles.entry_label} htmlFor='is_new'>
              {t('new')}
            </label>
          </div>
          <div className={styles.radio_input_container}>
            <input
              checked={!isNew}
              onChange={() => setIsNew(false)}
              className={styles.entry_input}
              type='radio'
              id='ongoing'
              name='ongoing'
            />
            <label className={styles.entry_label} htmlFor='ongoing'>
              {t('ongoing')}
            </label>
          </div>
        </div>
      )}
    </>
  )
}
